<div class="flex h-full min-h-0 flex-col flex-1 overflow-hidden">
    @if (loadingState() === 'loading') {
    <p class="py-10 text-center text-sm text-secondary">Loading team members…</p>
    } @else if (loadingState() === 'error') {
    <p class="py-10 text-center text-sm text-secondary">Failed to load team members.</p>
    } @else if (teamMembers().length === 0) {
    <p class="py-10 text-center text-sm text-secondary">No team members on this brand.</p>
    } @else {
    <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
        <div class="min-h-0 flex-1 overflow-x-auto overflow-y-auto scrollbar-transparent">
            <table class="min-w-full divide-y divide-gray-300 dark:divide-gray-700">
                <thead class="sticky top-0 z-10 bg-gray-100 dark:bg-gray-900/50">
                    <tr>
                        <th scope="col"
                            class="py-2 pr-3 pl-2 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Team member
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Role
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Job
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Active
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Invite
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-left text-sm font-semibold whitespace-nowrap text-primary">
                            Joined
                        </th>
                        <th scope="col"
                            class="px-2 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-primary">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                    @for (member of teamMembers(); track member.id) {
                    <tr>
                        <td class="py-2 pr-3 pl-2 text-sm whitespace-nowrap text-primary">
                            <div class="flex items-center">
                                <div class="relative flex size-10 shrink-0 items-center justify-center">
                                    <img class="size-10 rounded-full" [src]="
                          member.userAccount.photoURL
                            ? imageService.getImageSource(member.userAccount.photoURL, 'gallery')
                            : 'https://ionicframework.com/docs/img/demos/avatar.svg'
                        " alt="" />
                                </div>
                                <div class="ml-4 min-w-0">
                                    <div class="truncate font-medium text-primary">{{ memberDisplayName(member) }}</div>
                                    <div class="mt-1 truncate text-xs text-gray-500 dark:text-gray-400">
                                        {{ member.userAccount.email }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            <span>{{ userRoleLabel(member.userAccount.role) }}</span>
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            <span>{{ member.userAccount.jobPosition || '—' }}</span>
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (member.userAccount.isActive) {
                            <span
                                class="inline-flex rounded-md bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-800 ring-1 ring-inset ring-emerald-600/20 dark:bg-emerald-900/30 dark:text-emerald-200 dark:ring-emerald-700/40">
                                Active
                            </span>
                            } @else {
                            <span
                                class="inline-flex rounded-md bg-zinc-100 px-2 py-0.5 text-xs font-medium text-zinc-600 ring-1 ring-inset ring-zinc-500/20 dark:bg-zinc-800 dark:text-zinc-300 dark:ring-zinc-600/40">
                                Inactive
                            </span>
                            }
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (member.userAccount.inviteAccepted) {
                            <span
                                class="inline-flex rounded-md bg-sky-50 px-2 py-0.5 text-xs font-medium text-sky-800 ring-1 ring-inset ring-sky-600/20 dark:bg-sky-900/30 dark:text-sky-200 dark:ring-sky-700/40">
                                Accepted
                            </span>
                            } @else {
                            <span
                                class="inline-flex rounded-md bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-800 ring-1 ring-inset ring-amber-600/20 dark:bg-amber-900/30 dark:text-amber-200 dark:ring-amber-700/40">
                                Pending
                            </span>
                            }
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary">
                            @if (member.createdDate) {
                            <span>{{ member.createdDate | date: 'dd MMM yy HH:mm' }}</span>
                            } @else {
                            <span class="text-secondary">—</span>
                            }
                        </td>
                        <td class="px-2 py-2 text-sm whitespace-nowrap text-primary text-right">
                            <div class="inline-flex items-center justify-end gap-1">
                            @if (currentUserService.hasAnyRole(shoutInternalAccessRoles)) {
                            <button (click)="openUserProfile(member)" type="button" class="fab-button-secondary-small text-secondary" [appTooltip]="'User profile'" position="left">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5" aria-hidden="true">
                                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                                    <circle cx="12" cy="7" r="4" />
                                </svg>
                            </button>
                            }
                            @if (currentUserService.hasAnyRole([6])) {
                            <button (click)="triggerImpersonation(member.userAccount.firebaseUid, memberDisplayName(member))" type="button" class="fab-button-secondary-small text-secondary" [appTooltip]="'Impersonate'" position="left">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="size-5">
                                    <path d="m6 17 5-5-5-5" />
                                    <path d="m13 17 5-5-5-5" />
                                </svg>
                            </button>
                            }
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }

    @if (pendingImpersonation(); as pending) {
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="w-full max-w-sm rounded-xl bg-white dark:bg-zinc-900 p-6 shadow-xl ring-1 ring-gray-200 dark:ring-zinc-700">
            <h3 class="text-base font-semibold text-primary">Impersonate {{ pending.displayName }}</h3>
            <p class="mt-1 text-sm text-secondary">Enter your API key to take on this user's persona. Your access roles will be preserved.</p>

            <div class="mt-4">
                <label for="impersonate-api-key" class="block text-sm font-medium text-primary">API key</label>
                <input
                    id="impersonate-api-key"
                    type="password"
                    [value]="apiKeyInput()"
                    (input)="apiKeyInput.set($any($event.target).value)"
                    class="mt-1.5 block w-full rounded-md bg-white dark:bg-zinc-800 px-3 py-2 text-sm text-primary outline-1 -outline-offset-1 outline-gray-300 dark:outline-zinc-600 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary"
                    placeholder="Enter API key"
                    autocomplete="current-password"
                />
            </div>

            @if (impersonateError()) {
            <p class="mt-2 text-sm text-red-600 dark:text-red-400">{{ impersonateError() }}</p>
            }

            <div class="mt-5 flex justify-end gap-3">
                <button
                    type="button"
                    (click)="cancelImpersonation()"
                    [disabled]="isLoading()"
                    class="rounded-md px-3.5 py-2 text-sm font-semibold text-primary ring-1 ring-inset ring-gray-300 dark:ring-zinc-600 hover:bg-gray-50 dark:hover:bg-zinc-800 disabled:opacity-50">
                    Cancel
                </button>
                <button
                    type="button"
                    (click)="confirmImpersonation()"
                    [disabled]="isLoading() || !apiKeyInput()"
                    class="rounded-md bg-primary px-3.5 py-2 text-sm font-semibold text-white hover:bg-primary/90 disabled:opacity-50">
                    @if (isLoading()) {
                    Impersonating…
                    } @else {
                    Confirm
                    }
                </button>
            </div>
        </div>
    </div>
    }
</div>
